import { render, staticRenderFns } from "./requirement.vue?vue&type=template&id=af49ec0e&scoped=true"
import script from "./requirement.vue?vue&type=script&lang=js"
export * from "./requirement.vue?vue&type=script&lang=js"
import style0 from "./requirement.vue?vue&type=style&index=0&id=af49ec0e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af49ec0e",
  null
  
)

export default component.exports